import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import {
  convertIosDateToString,
  convertStringToDetailTime,
  renderGender,
} from "helper/common";
import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";
import React from "react";
import PatientTypeColumn from "components/common/ColumnColors/KCBTypeColumn/PatientTypeColumn";
import { loaiBNOptions } from "assets/constants/kbnt-category";
import ObjectTypeColumn from "components/common/ColumnColors/KCBTypeColumn/ObjectTypeColumn";
const { INPUT, SELECT, DATE, CODE, COMBO_BOX } = FIELD_TYPE;

const dataField: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    placeholder: "Nhập",
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "hoTen",
    placeholder: "Nhập",
  },
  {
    type: SELECT,
    label: "Phòng",
    name: "phongs",
    placeholder: "Chọn",
    options: [
      // {
      //   value: 1,
      //   label: "Khúc xạ",
      // },
      // {
      //   value: 2,
      //   label: "Điều dưỡng ngoại trú",
      // },
      // {
      //   value: 3,
      //   label: "Khám bệnh ngoại trú",
      // },
      // {
      //   value: 4,
      //   label: "Điện tim",
      // },
      // {
      //   value: 5,
      //   label: "Xét nghiệm",
      // },
      // {
      //   value: 6,
      //   label: "Chẩn đoán hình ảnh",
      // },
    ],
  },
  {
    type: DATE,
    label: "Thời gian từ",
    name: "start",
    // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },
  {
    type: DATE,
    label: "Thời gian đến",
    name: "end",
    // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },

  {
    type: SELECT,
    label: "Người thực hiện",
    name: "nvThucHien",
  },
];

const columnsTable: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    align: "center",
    fixed: "left",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    key: "maBenhNhan",
    width: "100px",
    align: "center",
  },
  {
    title: "Mã PK",
    dataIndex: "id",
    key: "id",
    width: "100px",
    align: "center",
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    key: "hoTen",
    width: "100px",
    align: "left",
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    key: "ngaySinh",
    width: "100px",
    align: "center",
    render: (v) => convertIosDateToString(v),
  },

  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    width: "100px",
    align: "left",
    render: (v) => renderGender(v),
  },
  {
    title: "Loại BN",
    dataIndex: "loaiBenhNhans",
    key: "loaiBenhNhans",
    width: "100px",
    align: "center",
    render: (text) => {
      const loaiBN =
        loaiBNOptions?.find((option) => option.value === text?.[0])?.label ||
        "";
      return <PatientTypeColumn label={loaiBN} />;
    },
  },
  {
    title: "Loại KCB",
    dataIndex: "loaiKcb",
    key: "loaiKcb",
    width: "100px",
    align: "center",
    render: (text) => {
      const ten =
        JSON.parse(localStorage.getItem("loaiKCB")).find(
          (option) => option.value === text
        )?.label || "";
      return <KCBTypeColumn label={ten} />;
    },
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuong",
    key: "doiTuong",
    width: "100px",
    align: "center",
    render: (text) => {
      const ten =
        JSON.parse(localStorage.getItem("doiTuong")).find(
          (option) => option.label === text
        )?.label || "";
      return <ObjectTypeColumn label={ten} />;
    },
  },
  {
    title: "Nguồn BN",
    dataIndex: "nguonBn",
    key: "nguonBn",
    width: "100px",
    align: "center",
  },
  {
    title: "Tiếp nhận",
    width: "100px",
    align: "center",
    children: [
  
      {
        title: "TG thực hiện",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianTN",
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvTN",
      },
    ],
  },
  {
    title: "Khúc xạ",
    width: "100px",
    align: "center",
    children: [
      {
        title: "TG chờ",
        width: "100px",
        dataIndex: "thoiGianChoKX",
        render: (v) => convertStringToDetailTime(v),
      },
      {
        title: "TG thực hiện",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianKhamKX",
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvKX",
      },
    ],
  },
  {
    title: "Điều dưỡng ngoại trú",
    width: "100px",
    align: "center",
    children: [
      {
        title: "TG chờ",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianChoDD",
      },
      {
        title: "TG thực hiện",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianKhamDD",
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvDD",
      },
    ],
  },
  {
    title: "Khám bệnh ngoại trú",
    width: "100px",
    align: "center",
    children: [
      {
        title: "TG chờ",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianChoKBNT",
      },
      {
        title: "TG thực hiện",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianKhamKBNT",
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvKBNT",
      },
    ],
  },
  {
    title: "Chẩn đoán hình ảnh",
    width: "100px",
    align: "center",
    children: [
      {
        title: "TG chờ",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianChoCDHA",
      },
      {
        title: "TG thực hiện",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianKhamCDHA",
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvCDHA",
      },
    ],
  },
  {
    title: "Điện tim",
    width: "100px",
    align: "center",
    children: [
      {
        title: "TG chờ",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianChoDT",
      },
      {
        title: "TG thực hiện",
        width: "100px",
        dataIndex: "thoiGianKhamDT",
        render: (v) => convertStringToDetailTime(v),
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvDT",
      },
    ],
  },
  {
    title: "Xét nghiệm",
    width: "100px",
    align: "center",
    children: [
      {
        title: "TG chờ",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianChoXN",
      },
      {
        title: "TG thực hiện",
        width: "100px",
        dataIndex: "thoiGianKhamXN",
        render: (v) => convertStringToDetailTime(v),
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvXN",
      },
    ],
  },
  {
    title: "Tư vấn",
    width: "100px",
    align: "center",
    children: [
      {
        title: "TG chờ",
        width: "100px",
        render: (v) => convertStringToDetailTime(v),
        dataIndex: "thoiGianChoTV",
      },
      {
        title: "TG thực hiện",
        width: "100px",
        dataIndex: "thoiGianKhamTV",
        render: (v) => convertStringToDetailTime(v),
      },
      {
        title: "Người thực hiện",
        width: "100px",
        dataIndex: "nvTV",
      },
    ],
  },
];

export { dataField, columnsTable };
